// Default class schedules, one per person.
//
// Read off the Herons / Indian cohort timetable for Fall 2026:
//
//   15.060 Section D   Mon & Wed 10:00–11:30  E62-262  (Podimata)
//   15.515 Indian      Tue & Thu 10:00–11:30  E62-276  (Weber)
//   15.280 D1          Tue       16:00–17:30  E62-250  (Kazakoff)
//   15.280 Comm Lab    Thu       15:00–16:00
//   15.311 Indian      Thu       16:00–17:30  E62-223  (Aeppli)
//
// Everyone shares those. The two that vary by section are seeded with Pun's — 15.010
// Section A and 15.900 Section D — as a starting point for the others to correct.
// Rahul is not in 15.900. 15.403 is Pun's elective until we hear otherwise.
//
// Block ids are stable so that per-week overrides in `ex` keep pointing at the right
// block across edits.

const shared = () => [
  { id: "b060a", cls: "15.060", day: "mon", start: "1000", end: "1130", room: "E62-262" },
  { id: "b060b", cls: "15.060", day: "wed", start: "1000", end: "1130", room: "E62-262" },
  { id: "b515a", cls: "15.515", day: "tue", start: "1000", end: "1130", room: "E62-276" },
  { id: "b515b", cls: "15.515", day: "thu", start: "1000", end: "1130", room: "E62-276" },
  { id: "b280a", cls: "15.280", day: "tue", start: "1600", end: "1730", room: "E62-250" },
  { id: "b280lab", cls: "15.280", label: "Comm Lab", day: "thu", start: "1500", end: "1600", room: "" },
  { id: "b311a", cls: "15.311", day: "thu", start: "1600", end: "1730", room: "E62-223" },
];

const econ = () => [
  { id: "b010a", cls: "15.010", day: "tue", start: "0830", end: "1000", room: "E62-262" },
  { id: "b010b", cls: "15.010", day: "thu", start: "0830", end: "1000", room: "E62-262" },
];

const strategy = () => [
  { id: "b900a", cls: "15.900", day: "mon", start: "1430", end: "1600", room: "E51-325" },
  { id: "b900b", cls: "15.900", day: "wed", start: "1430", end: "1600", room: "E51-325" },
];

const finance = () => [{ id: "b403a", cls: "15.403", day: "mon", start: "1600", end: "1730", room: "E62-276" }];

export const SEED_SCHEDULE = {
  pun: { blocks: [...econ(), ...shared(), ...strategy(), ...finance()], ex: {} },
  ivi: { blocks: [...econ(), ...shared(), ...strategy()], ex: {} },
  charlie: { blocks: [...econ(), ...shared(), ...strategy()], ex: {} },
  anthony: { blocks: [...econ(), ...shared(), ...strategy()], ex: {} },
  rahul: { blocks: [...econ(), ...shared()], ex: {} }, // not in 15.900
  sofia: { blocks: [...econ(), ...shared(), ...strategy()], ex: {} },
};
